type BetaFeatureId = 'public-explore' | 'ask-roam-interactive-edits' | 'itinerary-map-tools';

export type BetaFeature = {
  id: BetaFeatureId;
  label: string;
  shortLabel: string;
  description: string;
  productionSurface: string;
};

export const BETA_FEATURES: BetaFeature[] = [
  {
    id: 'public-explore',
    label: 'Public Explore trips',
    shortLabel: 'Explore',
    description: 'Browse public family itineraries and fork one into a private workspace.',
    productionSurface: '/explore',
  },
  {
    id: 'ask-roam-interactive-edits',
    label: 'Ask Roam interactive edits',
    shortLabel: 'Ask Roam',
    description: 'Use proposal cards, apply/undo controls, and itinerary-linked chat suggestions.',
    productionSurface: '/trips/[id]/chat',
  },
  {
    id: 'itinerary-map-tools',
    label: 'Itinerary map tools',
    shortLabel: 'Map tools',
    description: 'Review route/map context alongside scheduled trip cards.',
    productionSurface: '/trips/[id]',
  },
];
